import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { IOrderXferService, CHANNEL_ORDER_XFER_SERVICE } from "../IOrderXferService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderXferReplicaService implements IOrderXferService {
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(CHANNEL_ORDER_XFER_SERVICE, true, true);
  }

  public requestXfer(
    ids: Array<string>,
    comment: string,
    xferAction: CubiqTS.XferAction,
    targetGroupId: string,
  ): Promise<boolean> {
    let request = new UiArguments("requestXfer");

    if (targetGroupId == null) {
      logger.out.error(
        `${this.constructor.name}.requestXfer() ignoring request invalid targetGroupId: ids:${ids} comment:${comment} action:${CubiqTS.XferAction[xferAction]} targetGroupId:${targetGroupId} `,
      );
      logger.out.error(`${new Error().stack}`);

      return new Promise<boolean>((res, rej) => {
        rej();
      });
    }

    request.args = [
      new FnArg(ids, PRIMITIVE),
      new FnArg(comment, PRIMITIVE),
      new FnArg(xferAction, PRIMITIVE),
      new FnArg(targetGroupId, PRIMITIVE),
    ];

    return this.broker.runOnService(request, PRIMITIVE);
  }
}
